(() => {
  const root = document.querySelector('[data-si-support]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const app = document.getElementById('track123-app');
  if (!app) return;
  const enhance = () => {
    app.querySelectorAll('input[placeholder]').forEach((input) => {
      if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', input.getAttribute('placeholder'));
    });
    app.querySelectorAll('.track123_tab_bar').forEach((tab) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', String(tab.classList.contains('track123_tab_bar_color')));
      tab.tabIndex = 0;
      if (!tab.dataset.siKeyboard) {
        tab.dataset.siKeyboard = 'true';
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); tab.click(); }
        });
      }
    });
    const tablist = app.querySelector('.track123_tab');
    if (tablist) { tablist.setAttribute('role', 'tablist'); tablist.setAttribute('aria-label', 'Search by order or tracking number'); }
  };
  new MutationObserver(enhance).observe(app, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
  enhance();
  document.querySelectorAll('a[href="#email-support"]').forEach((link) => {
    link.addEventListener('click', () => {
      const fieldMap = [
        ['Order Number', 'contact[Order number]'],
        ['Tracking Number', 'contact[Tracking number]'],
        ['Email or Phone Number', 'contact[email]']
      ];
      fieldMap.forEach(([placeholder, name]) => {
        const source = app.querySelector(`input[placeholder="${placeholder}"]`);
        const target = root.querySelector(`[name="${name}"]`);
        if (!source || !target || target.value || !source.value.trim()) return;
        if (name === 'contact[email]' && !source.value.includes('@')) return;
        target.value = source.value.trim().slice(0, target.maxLength > 0 ? target.maxLength : 254);
      });
    });
  });
})();
